export const BASE_URL = "https://api.milanese.am/product/api/v1";
export const _hostMediaUrl =  "https://api.milanese.am/file/resources";

export const WEB_PAGE_URL = "https://stage.milanese.am";

// export const BASE_URL = "http://173.212.233.220:3202/api/v1";
// export const _hostMediaUrl =  "http://173.212.233.220:3203/resources";
//
// export const WEB_PAGE_URL = "http://milanese.solidy.am";